import React, { useState, useEffect, useRef, useContext } from "react";
import { Button, InputGroup, Modal, Form, Container } from 'react-bootstrap';
import C4FInfoButton from "./C4FInfoButton";
import { LocalizationContext } from "../main/LocalizationContext";
import '../css/Race.css';

function DataCaptureModal(props) {

    const mounted = useRef(false);
    const { getLocalizedText } = useContext(LocalizationContext);
    const [show, setShow] = useState(false);
    const [data, setData] = useState(props.data);

    function handleCancel() {
        setShow(false);
        props.callbackCancel();
    }

    function handleOK() {
        setShow(false);
        props.callbackOK(data);
    }

    useEffect(() => {
        mounted.current = true;
    }, []);

    useEffect(() => {
        return () => mounted.current = false;
    }, []);

    useEffect(() => {
        if (mounted.current) {
            setShow(props.show);
        }
    }, [props.show]);

    return <>
        <Modal key={'DataCaptureModal' + show}
            size={props.size ? props.size : 'm'}
            centered
            show={show}
            onHide={handleCancel} >
            <Modal.Header>
                <Modal.Title>{props.title ? props.title : 'Enter Data'}</Modal.Title>
                <Button className="py-0 m-0" variant="danger" onClick={() => handleCancel()}>{'X'}</Button>
            </Modal.Header>
            <Modal.Body closeButton style={{ backgroundColor: 'rgba(222,233,244,1)', padding: 0, margin: 0 }}>
                <Container className="p-1">
                    {data ?
                        data.map(record =>
                            <InputGroup>
                                {record.info ?
                                    <C4FInfoButton title={record.parameterName} text={record.info} />
                                    : null}
                                <InputGroup.Text>{record.parameterName}</InputGroup.Text>
                                <Form.Control type={'text'} value={record.parameterValue}
                                    onChange={(e) => setData(data.map(r => r.parameterName === record.parameterName ? { ...r, parameterValue: e.target.value } : r))} />
                            </InputGroup>
                        )
                        : null}
                </Container>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="danger" onClick={() => handleCancel()}>{getLocalizedText('common', 'Cancel')}</Button>
                <Button variant="success" onClick={() => handleOK()}>{getLocalizedText('common', 'OK')}</Button>
            </Modal.Footer>
        </Modal>
    </>
}

export default DataCaptureModal;